module.exports = __webpack_public_path__ + "img/icon_success.320ae814.svg";